import { Injectable } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class RoutingState {
  private history: string[] = [];

  constructor(private router: Router) {
    this.loadRouting();
  }

  private loadRouting(): void {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe({
        next: ({ urlAfterRedirects }: NavigationEnd) => {
          this.history = [...this.history, urlAfterRedirects];
        },
        error: (error) => {
          throw new Error(error);
        },
      });
  }

  public getPreviousUrl(): string {
    return this.history[this.history.length - 2];
  }

  public navigatedFrom(url: string): boolean {
    return this.getPreviousUrl() == url;
  }

  public navigatedFromManage(): boolean {
    return this.navigatedFrom("/manage");
  }
}
